<template>
  <b-container>
    <h1 v-translate>Backoffice Preferences</h1>
    <hr>
    <div class="row">
      <div class="col-md-3">
        <profile-navigation />
      </div>
      <div class="col-md-9 personal-info">
        <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
          <p v-translate>Backoffice Preferences were updated!</p>
        </b-alert>
        <form class="" role="form" @submit.prevent="submit()" v-if="meta.backofficePreferences">
          <b-row class="mb-5">
            <h3 class="col-12" v-translate>Companies <small>(will apply wherever it's possible)</small></h3>
            <b-col>
              <b-form-group>
                <h4 v-translate>Exclude</h4>
                <company-autocomplete ref="excludeCompanyAc" @selected="onExcludeCompanySelected" />
                <b-badge v-for="(item, index) in meta.backofficePreferences.companies.exclude.objs" :key="index" style="margin-right: 3px">
                  {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeCompanyFromExclude(index)">×</b-badge>
                </b-badge>&nbsp;
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <h4 v-translate>Include <small>(will show Includes ONLY)</small> </h4>
                <company-autocomplete ref="includeCompanyAc" @selected="onIncludeCompanySelected" />
                <b-badge v-for="(item, index) in meta.backofficePreferences.companies.include.objs" :key="index" style="margin-right: 3px">
                  {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeCompanyFromInclude(index)">×</b-badge>
                </b-badge>&nbsp;
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-container>
              <b-row>
                <h3 class="col-12" v-translate>Defaults</h3>
              </b-row>
              <b-form-row class="mb-3">
                <b-col sm="4" lg="3">
                  <label class="col-form-label control-label" v-translate>Listings Row Quantity</label>
                </b-col>
                <b-col sm="4" lg="3">
                  <b-form-select cols="2" :options="pageOptions" v-model="meta.backofficePreferences.defaults.listings.limit" />
                </b-col>
              </b-form-row>
            </b-container>
          </b-row>
          <b-row>
            <b-col class="form-actions mt-4">
              <b-button type="submit" variant="primary" size="lg" v-translate>Save Changes</b-button>
            </b-col>
          </b-row>
        </form>
      </div>
    </div>
  </b-container>
</template>
<script>

import ProfileNavigation from '@/components/ProfileNavigation'
import { mapGetters } from 'vuex'
import { FETCH_PROFILE, UPDATE_USER } from '@/store/actions.type'
import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'

export default {
  name: 'ProfileBackofficePreferencesPage',
  title() {
    return this.$gettext('Backoffice Preferences « Edit Profile')
  },
  components: {
    ProfileNavigation,
    CompanyAutocomplete
  },
  data() {
    return {
      breadcrumb: [{
        text: 'Home',
        to: { name: 'index' }
      }, {
        text: 'Profile',
        to: { name: 'profile' }
      }, {
        text: 'Backoffice Preferences',
        active: true
      }],
      meta: {},
      pageOptions: [ 10, 25, 50, 100, 500 ],
      companyAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('Company Name, Business Name or TIN'),
        inputClass: 'form-control',
        minCharacter: 2
      },
      searchExcludeCompanyQuery: '',
      searchIncludeCompanyQuery: '',
      formSaved: false,
      dismissSecs: 10,
      dismissCountDown: 0
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'isLoading'
    ])
  },
  created() {
    this.fetchProfile()
  },
  methods: {
    fetchProfile() {
      this.$store.dispatch(FETCH_PROFILE)
        .then(response => {
          if (this.user.meta !== null) {
            try {
              this.meta = JSON.parse(this.user.meta)
            } catch (e) {
              this.meta = this.user.meta
            }
            if (!this.meta.backofficePreferences) {
              this.$set(this.meta, 'backofficePreferences', {
                companies: {
                  exclude: {
                    ids: [],
                    objs: []
                  },
                  include: {
                    ids: [],
                    objs: []
                  }
                },
                defaults: {
                  listings: {
                    limit: 25
                  }
                }
              })
            }
          } else {
            this.meta = {
              backofficePreferences: {
                companies: {
                  exclude: {
                    ids: [],
                    objs: []
                  },
                  include: {
                    ids: [],
                    objs: []
                  }
                },
                defaults: {
                  listings: {
                    limit: 25
                  }
                }
              }
            }
          }
        }, error => {
          let obj = {
            title: this.$gettext('ERROR'),
            message: error.body.message,
            type: 'error'
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        })
    },
    submit() {
      this.$store.dispatch(UPDATE_USER, { meta: JSON.stringify(this.meta) })
        .then(response => {
          this.showAlert()
          this.fetchProfile()
        })
    },
    onExcludeCompanySelected(item) {
      if (this.meta.backofficePreferences.companies.exclude.ids.indexOf(item.id) === -1) {
        this.meta.backofficePreferences.companies.exclude.objs.push({id: item.id, name: item.name})
        this.meta.backofficePreferences.companies.exclude.ids.push(item.id)
      }
      this.$refs.excludeCompanyAc.searchQuery = ''
    },
    removeCompanyFromExclude(index) {
      this.meta.backofficePreferences.companies.exclude.objs.splice(index, 1)
      this.meta.backofficePreferences.companies.exclude.ids.splice(index, 1)
    },
    onIncludeCompanySelected(item) {
      if (this.meta.backofficePreferences.companies.include.ids.indexOf(item.id) === -1) {
        this.meta.backofficePreferences.companies.include.objs.push({id: item.id, name: item.name})
        this.meta.backofficePreferences.companies.include.ids.push(item.id)
      }
      this.$refs.includeCompanyAc.searchQuery = ''
    },
    removeCompanyFromInclude(index) {
      this.meta.backofficePreferences.companies.include.objs.splice(index, 1)
      this.meta.backofficePreferences.companies.include.ids.splice(index, 1)
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}

</script>
